import { render, staticRenderFns } from "./FollowUpRecord.vue?vue&type=template&id=a1b29f40&scoped=true"
import script from "./FollowUpRecord.vue?vue&type=script&lang=js"
export * from "./FollowUpRecord.vue?vue&type=script&lang=js"
import style0 from "./FollowUpRecord.vue?vue&type=style&index=0&id=a1b29f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b29f40",
  null
  
)

export default component.exports